module.exports = __webpack_public_path__ + "img/tools@2x.6bd1374.webp";